import React from "react";
import HemaLogo from "../assets/images/HematogenixRed.svg";
import ForgetPassword from "../components/auth/forget-password";
import { Alert } from "../utils";
import AuthLanding from "../components/auth/authLanding";
const PortalLogin = () => {
  return (
    <div className="flex w-full">
      <AuthLanding className="bg-[url(../../assets/images/bg-reset-password.png)]" />
      <div className="p-7 lg:pl-[70px]  w-full lg:w-[50%] min-h-screen lg:min-h-auto bg-hemaSecondary">
        <div className="mt-8 lg:mt-[60px] mb-[62px] lg:mb-[104px]">
          <img src={HemaLogo} alt="Company logo" />
        </div>
        <Alert />
        <ForgetPassword />
      </div>
    </div>
  );
};

export default PortalLogin;
